// // CreditNoteManagement - UPDATED VERSION WITH customer_zoho_id
// import { useState, useEffect, useCallback } from 'react';
// import { Plus, Edit2, Trash2, RefreshCcw, Save, X, Search, Filter } from 'lucide-react';

// const CreditNoteManagement = () => {
//     const [creditNotes, setCreditNotes] = useState([]);
//     const [isLoading, setIsLoading] = useState(false);
//     const [showForm, setShowForm] = useState(false);
//     const [editingCredit, setEditingCredit] = useState(null);
//     const [customerSuggestions, setCustomerSuggestions] = useState([]);
//     const [showCustomerSuggestions, setShowCustomerSuggestions] = useState(false);
//     const [pagination, setPagination] = useState({
//         page: 1,
//         limit: 10,
//         total: 0,
//         totalPages: 0
//     });
//     const [searchTerm, setSearchTerm] = useState('');
//     const [filter, setFilter] = useState('all');

//     const [formData, setFormData] = useState({
//         customer_name: '',
//         customer_zoho_id: '', // Changed from customer_id
//         invoice_number: '',
//         invoice_date: '',
//         balance: '',
//         credit_note_amount: '',
//         currency_id: '3000000000083',
//         vat_treatment: '',
//         credit_note_number: '',
//         gst_treatment: 'business_gst',
//         tax_treatment: 'vat_registered',
//         gst_no: '',
//         source_of_supply: 'TN',
//         destination_of_supply: 'TN',
//         place_of_supply: 'DU',
//         pricebook_id: '',
//         reference_number: '',
//         is_update_customer: false,
//         exchange_rate: 1,
//         is_inclusive_tax: false,
//         location_id: '',
//         line_items: [{
//             item_id: '',
//             name: '',
//             description: '',
//             quantity: 1,
//             unit: 'Nos',
//             rate: 0,
//             tax_id: '',
//             hsn_or_sac: ''
//         }],
//         notes: '',
//         custom_fields: [],
//         company_id: '',
//         autoSync: false
//     });

//     // Organization state
//     const [currentOrganization, setCurrentOrganization] = useState({
//         organization_id: '',
//         name: ''
//     });

//     const API_BASE_URL = 'https://api.zapbooksai.subraps.com/api';

//     // Get authentication headers
//     const getAuthHeaders = () => {
//         const token = localStorage.getItem('authToken') || sessionStorage.getItem('authToken');
//         return {
//             'Content-Type': 'application/json',
//             ...(token && { 'Authorization': `Bearer ${token}` })
//         };
//     };

//     // Safe fetch with better error handling
//     const safeFetch = async (url, options = {}) => {
//         try {
//             console.log(`Making request to: ${url}`);
//             console.log(`Request options:`, options);

//             const response = await fetch(url, options);

//             console.log(`Response status: ${response.status} ${response.statusText}`);

//             if (!response.ok) {
//                 const errorText = await response.text();
//                 console.error(`HTTP Error ${response.status}:`, errorText);
//                 throw new Error(`HTTP ${response.status}: ${response.statusText}`);
//             }

//             const result = await response.json();
//             console.log(`Response data:`, result);
//             return result;
//         } catch (error) {
//             console.error(`Fetch error for ${url}:`, error);
//             throw error;
//         }
//     };

//     // Fetch current organization
//     const fetchCurrentOrganization = async () => {
//         try {
//             console.log('Fetching current organization...');
//             const result = await safeFetch(`${API_BASE_URL}/token/status`, {
//                 headers: getAuthHeaders()
//             });

//             if (result.success && result.data.current_organization) {
//                 const org = result.data.current_organization;
//                 console.log('Current organization fetched:', org);
//                 setCurrentOrganization(org);
//                 return org.organization_id;
//             } else {
//                 console.error('No current organization found');
//                 throw new Error('No current organization found');
//             }
//         } catch (error) {
//             console.error('Error fetching current organization:', error);
//             throw error;
//         }
//     };

//     // Initialize component
//     useEffect(() => {
//         const initializeComponent = async () => {
//             try {
//                 await fetchCurrentOrganization();
//             } catch (error) {
//                 console.error('Failed to initialize component:', error);
//             }
//         };

//         initializeComponent();
//     }, []);

//     // Fetch credit notes when organization is ready
//     useEffect(() => {
//         if (currentOrganization?.organization_id) {
//             fetchCreditNotes();
//         }
//     }, [pagination.page, searchTerm, filter, currentOrganization?.organization_id]);

//     // NEW: Search customers directly in Zoho Books
//     const fetchCustomerSuggestions = useCallback(async (searchName) => {
//         if (!searchName || searchName.length < 2 || !currentOrganization?.organization_id) {
//             setCustomerSuggestions([]);
//             return;
//         }

//         try {
//             console.log(`Searching for customers in Zoho with name: "${searchName}"`);

//             const url = new URL(`${API_BASE_URL}/customers/search-zoho`);
//             url.searchParams.set('name', searchName);
//             url.searchParams.set('company_id', currentOrganization.organization_id);

//             console.log(`Search URL: ${url.toString()}`);

//             const result = await safeFetch(url.toString(), {
//                 headers: getAuthHeaders()
//             });

//             if (result.success && result.data) {
//                 setCustomerSuggestions(result.data);
//                 console.log('Customer suggestions set:', result.data);
//             } else {
//                 setCustomerSuggestions([]);
//                 console.log('No customer suggestions found');
//             }
//         } catch (error) {
//             console.error('Error fetching customer suggestions:', error);
//             setCustomerSuggestions([]);
//         }
//     }, [currentOrganization?.organization_id]);

//     // NEW: Get customer details directly from Zoho Books
//     const fetchCustomerDetails = useCallback(async (customerZohoId) => { // Changed parameter name
//         if (!customerZohoId || !currentOrganization?.organization_id) {
//             console.log('No customer Zoho ID or organization ID provided');
//             return;
//         }

//         try {
//             console.log(`Fetching customer details from Zoho for ID: ${customerZohoId}`);

//             const url = new URL(`${API_BASE_URL}/customers/details-zoho`);
//             url.searchParams.set('customer_zoho_id', customerZohoId); // Changed parameter name
//             url.searchParams.set('company_id', currentOrganization.organization_id);

//             console.log(`Details URL: ${url.toString()}`);

//             const result = await safeFetch(url.toString(), {
//                 headers: getAuthHeaders()
//             });

//             if (result.success && result.data) {
//                 const customerData = result.data;
//                 console.log('Customer data received from Zoho:', customerData);

//                 setFormData(prevFormData => {
//                     const updatedFormData = {
//                         ...prevFormData,
//                         customer_zoho_id: customerData.customer_zoho_id || '', // Changed field name
//                         gst_no: customerData.gst_no || '',
//                         gst_treatment: customerData.gst_treatment || 'business_gst',
//                         tax_treatment: customerData.tax_treatment || 'vat_registered',
//                         source_of_supply: customerData.source_of_supply || 'TN',
//                         destination_of_supply: customerData.destination_of_supply || 'TN',
//                         place_of_supply: customerData.place_of_supply || 'DU'
//                     };
//                     console.log('Form data updated with Zoho customer info:', updatedFormData);
//                     console.log('Customer Zoho ID set to:', updatedFormData.customer_zoho_id); // Updated log message
//                     return updatedFormData;
//                 });

//             } else {
//                 console.log('Customer not found in Zoho, resetting fields');
//                 setFormData(prevFormData => ({
//                     ...prevFormData,
//                     customer_zoho_id: '', // Changed field name
//                     gst_no: '',
//                     gst_treatment: 'business_gst',
//                     tax_treatment: 'vat_registered',
//                     source_of_supply: 'TN',
//                     destination_of_supply: 'TN',
//                     place_of_supply: 'DU'
//                 }));
//             }
//         } catch (error) {
//             console.error('Error fetching customer details from Zoho:', error);
//             alert(`Error fetching customer details: ${error.message}`);
//         }
//     }, [currentOrganization?.organization_id]);

//     // Invoice line items fetching from Zoho Books
//     const fetchInvoiceLineItems = useCallback(async (invoiceNumber, customerZohoId) => { // Changed parameter name
//         if (!invoiceNumber || !invoiceNumber.trim() || !currentOrganization?.organization_id) {
//             console.log('No invoice number or organization ID provided');
//             return;
//         }

//         try {
//             console.log(`Fetching line items from Zoho for invoice: "${invoiceNumber}", customer: "${customerZohoId}"`);
//             setIsLoading(true);

//             const url = new URL(`${API_BASE_URL}/invoices/line-items-zoho`);
//             url.searchParams.set('invoice_number', invoiceNumber.trim());
//             url.searchParams.set('company_id', currentOrganization.organization_id);

//             if (customerZohoId && customerZohoId.trim()) {
//                 url.searchParams.set('customer_zoho_id', customerZohoId.trim()); // Changed parameter name
//             }

//             console.log(`Line items URL: ${url.toString()}`);

//             const result = await safeFetch(url.toString(), {
//                 headers: getAuthHeaders()
//             });

//             if (result.success && result.data) {
//                 const invoiceData = result.data;
//                 console.log('Invoice data received from Zoho:', invoiceData);

//                 setFormData(prevFormData => {
//                     const updatedFormData = {
//                         ...prevFormData,
//                         invoice_date: invoiceData.invoice_date ? new Date(invoiceData.invoice_date).toISOString().split('T')[0] : prevFormData.invoice_date,
//                         line_items: (invoiceData.line_items && invoiceData.line_items.length > 0) ? invoiceData.line_items : prevFormData.line_items,
//                         credit_note_amount: invoiceData.total_amount ? invoiceData.total_amount.toString() : prevFormData.credit_note_amount,
//                         place_of_supply: invoiceData.place_of_supply || prevFormData.place_of_supply
//                     };
//                     console.log('Form data updated with Zoho invoice info:', updatedFormData);
//                     return updatedFormData;
//                 });

//             } else {
//                 console.log('Invoice not found in Zoho:', result.message);
//                 alert('Invoice not found or no line items available');
//             }
//         } catch (error) {
//             console.error('Error fetching invoice line items from Zoho:', error);
//             alert(`Error fetching invoice details: ${error.message}`);
//         } finally {
//             setIsLoading(false);
//         }
//     }, [currentOrganization?.organization_id]);

//     // Handle customer name change with debouncing
//     const handleCustomerNameChange = async (value) => {
//         console.log('Customer name changed to:', value);

//         setFormData(prev => ({ ...prev, customer_name: value }));

//         if (value && value.length >= 2) {
//             await fetchCustomerSuggestions(value);
//             setShowCustomerSuggestions(true);
//         } else {
//             setShowCustomerSuggestions(false);
//             setCustomerSuggestions([]);
//         }
//     };

//     // Handle customer selection from dropdown
//     const handleCustomerSelect = async (customer) => {
//         console.log('Customer selected:', customer);

//         setFormData(prev => ({
//             ...prev,
//             customer_name: customer.customer_name,
//             customer_zoho_id: customer.customer_zoho_id // Changed field name
//         }));
//         setShowCustomerSuggestions(false);
//         setCustomerSuggestions([]);

//         // Fetch additional customer details after selection
//         await fetchCustomerDetails(customer.customer_zoho_id); // Changed parameter
//     };

//     // Handle customer name blur
//     const handleCustomerNameBlur = async () => {
//         console.log('Customer name blur event');

//         // Hide suggestions after a delay to allow for clicks
//         setTimeout(() => {
//             setShowCustomerSuggestions(false);
//         }, 200);

//         // If there's a customer name but no customer_zoho_id, try to find exact match
//         if (formData.customer_name && formData.customer_name.trim() && !formData.customer_zoho_id) { // Changed field name
//             await fetchCustomerSuggestions(formData.customer_name.trim());
//         }
//     };

//     // Handle invoice number change
//     const handleInvoiceNumberChange = (value) => {
//         console.log('Invoice number changed to:', value);
//         setFormData(prev => ({ ...prev, invoice_number: value }));
//     };

//     // Handle invoice number blur (fetch line items)
//     const handleInvoiceNumberBlur = async () => {
//         console.log('Invoice number blur event');

//         if (formData.invoice_number && formData.invoice_number.trim() && formData.customer_zoho_id && formData.customer_zoho_id.trim()) { // Changed field name
//             await fetchInvoiceLineItems(formData.invoice_number.trim(), formData.customer_zoho_id.trim()); // Changed parameter
//         }
//     };

//     const fetchCreditNotes = async () => {
//         if (!currentOrganization?.organization_id) {
//             console.log('No organization ID available, skipping load');
//             return;
//         }

//         setIsLoading(true);
//         try {
//             const url = new URL(`${API_BASE_URL}/credit-notes`);
//             url.searchParams.set('page', pagination.page);
//             url.searchParams.set('limit', pagination.limit);
//             url.searchParams.set('company_id', currentOrganization.organization_id);

//             console.log('Fetching credit notes with URL:', url.toString());

//             const result = await safeFetch(url.toString(), {
//                 headers: getAuthHeaders()
//             });

//             if (result.success) {
//                 console.log('Credit notes received:', result.data.creditNotes);

//                 setCreditNotes(result.data.creditNotes);
//                 setPagination(prev => ({
//                     ...prev,
//                     total: result.data.total,
//                     totalPages: result.data.totalPages
//                 }));
//             } else {
//                 console.error('Failed to fetch credit notes:', result.message);
//             }
//         } catch (error) {
//             console.error('Error fetching credit notes:', error);
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         console.log('Submitting form with data:', formData);

//         // Enhanced validation for required fields
//         if (!formData.customer_name || !formData.customer_name.trim()) {
//             alert('Customer name is required');
//             return;
//         }

//         if (!formData.customer_zoho_id || !formData.customer_zoho_id.trim()) { // Changed field name
//             alert('Customer Zoho ID is required. Please select a valid customer from the dropdown.');
//             return;
//         }

//         if (!currentOrganization?.organization_id) {
//             alert('No organization selected. Please ensure you are logged into Zoho Books.');
//             return;
//         }

//         // Additional validation...
//         if (!formData.invoice_number || !formData.invoice_number.trim()) {
//             alert('Invoice number is required');
//             return;
//         }

//         if (!formData.invoice_date) {
//             alert('Invoice date is required');
//             return;
//         }

//         if (!formData.credit_note_amount || parseFloat(formData.credit_note_amount) <= 0) {
//             alert('Credit note amount must be greater than 0');
//             return;
//         }

//         // Validate line items
//         if (!formData.line_items || formData.line_items.length === 0) {
//             alert('At least one line item is required');
//             return;
//         }

//         const validLineItems = formData.line_items.filter(item =>
//             item.name && item.name.trim() !== '' &&
//             item.quantity > 0
//         );

//         if (validLineItems.length === 0) {
//             alert('At least one valid line item with name and quantity > 0 is required');
//             return;
//         }

//         setIsLoading(true);

//         try {
//             // Format the data for backend with current organization
//             const formattedData = {
//                 ...formData,
//                 customer_zoho_id: formData.customer_zoho_id.toString().trim(), // Changed field name
//                 customer_name: formData.customer_name.trim(),
//                 company_id: currentOrganization.organization_id,
//                 invoice_date: formData.invoice_date ? new Date(formData.invoice_date).toISOString() : null,
//                 credit_note_amount: parseFloat(formData.credit_note_amount) || 0,
//                 balance: formData.balance ? parseFloat(formData.balance) : null,
//                 exchange_rate: parseFloat(formData.exchange_rate) || 1,
//                 is_update_customer: Boolean(formData.is_update_customer),
//                 is_inclusive_tax: Boolean(formData.is_inclusive_tax),
//                 autoSync: Boolean(formData.autoSync),
//                 line_items: validLineItems
//             };

//             console.log('Sending formatted data:', formattedData);
//             console.log('Final customer_zoho_id being sent:', formattedData.customer_zoho_id); // Updated log message
//             console.log('Organization ID being sent:', formattedData.company_id);

//             const url = editingCredit ? `${API_BASE_URL}/credit-notes/${editingCredit.id}` : `${API_BASE_URL}/credit-notes`;
//             const method = editingCredit ? 'PUT' : 'POST';

//             const result = await safeFetch(url, {
//                 method,
//                 headers: getAuthHeaders(),
//                 body: JSON.stringify(formattedData),
//             });

//             if (result.success) {
//                 setShowForm(false);
//                 setEditingCredit(null);
//                 resetForm();
//                 alert(editingCredit ? 'Credit Note updated successfully!' : 'Credit Note created successfully!');
//                 fetchCreditNotes();
//             } else {
//                 alert('Error: ' + result.message);
//             }
//         } catch (error) {
//             console.error('Error saving credit note:', error);
//             alert('Error saving credit note: ' + error.message);
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     const handleEdit = (credit) => {
//         console.log('Editing credit note:', credit);
//         setEditingCredit(credit);

//         // Convert DB date to local date string
//         const dbDate = credit.invoice_date ? new Date(credit.invoice_date) : null;
//         const localDate = dbDate ?
//             `${dbDate.getFullYear()}-${String(dbDate.getMonth() + 1).padStart(2, '0')}-${String(dbDate.getDate()).padStart(2, '0')}` :
//             '';

//         // Enhanced line items parsing
//         let parsedLineItems = [];
//         try {
//             if (credit.line_items) {
//                 if (typeof credit.line_items === 'string') {
//                     parsedLineItems = JSON.parse(credit.line_items);
//                 } else if (Array.isArray(credit.line_items)) {
//                     parsedLineItems = credit.line_items;
//                 } else if (typeof credit.line_items === 'object') {
//                     parsedLineItems = [credit.line_items];
//                 } else {
//                     parsedLineItems = [];
//                 }
//             }
//         } catch (e) {
//             console.error('Error parsing line items:', e);
//             parsedLineItems = [];
//         }

//         // Format and validate line items
//         const formattedLineItems = parsedLineItems
//             .filter(item => item && typeof item === 'object')
//             .map(item => ({
//                 item_id: item.item_id || '',
//                 name: item.name || '',
//                 description: item.description || '',
//                 quantity: parseFloat(item.quantity) || 1,
//                 unit: item.unit || 'Nos',
//                 rate: parseFloat(item.rate) || 0,
//                 tax_id: item.tax_id || '',
//                 hsn_or_sac: item.hsn_or_sac || '',
//                 account_id: item.account_id || ''
//             }))
//             .filter(item => item.name.trim() !== '' || item.rate > 0 || item.quantity > 0);

//         // If no valid line items, add a default one
//         if (formattedLineItems.length === 0) {
//             formattedLineItems.push({
//                 item_id: '',
//                 name: '',
//                 description: '',
//                 quantity: 1,
//                 unit: 'Nos',
//                 rate: 0,
//                 tax_id: '',
//                 hsn_or_sac: '',
//                 account_id: ''
//             });
//         }

//         // Set all form data
//         const editFormData = {
//             customer_name: credit.customer_name || '',
//             customer_zoho_id: credit.customer_zoho_id || '', // Changed field name
//             invoice_number: credit.invoice_number || '',
//             invoice_date: localDate,
//             balance: credit.balance || '',
//             credit_note_amount: credit.credit_note_amount || '',
//             currency_id: credit.currency_id || '3000000000083',
//             vat_treatment: credit.vat_treatment || '',
//             credit_note_number: credit.credit_note_number || '',
//             gst_treatment: credit.gst_treatment || 'business_gst',
//             tax_treatment: credit.tax_treatment || 'vat_registered',
//             gst_no: credit.gst_no || '',
//             source_of_supply: credit.source_of_supply || 'TN',
//             destination_of_supply: credit.destination_of_supply || 'TN',
//             place_of_supply: credit.place_of_supply || 'DU',
//             pricebook_id: credit.pricebook_id || '',
//             reference_number: credit.reference_number || '',
//             is_update_customer: credit.is_update_customer || false,
//             exchange_rate: credit.exchange_rate || 1,
//             is_inclusive_tax: credit.is_inclusive_tax || false,
//             location_id: credit.location_id || '',
//             line_items: formattedLineItems,
//             notes: credit.notes || '',
//             custom_fields: credit.custom_fields || [],
//             company_id: credit.company_id || currentOrganization?.organization_id,
//             autoSync: false
//         };

//         console.log('Setting edit form data:', editFormData);
//         setFormData(editFormData);
//         setShowForm(true);
//     };

//     const handleDelete = async (id) => {
//         if (window.confirm('Are you sure you want to delete this credit note?')) {
//             try {
//                 const result = await safeFetch(`${API_BASE_URL}/credit-notes/${id}`, {
//                     method: 'DELETE',
//                     headers: getAuthHeaders()
//                 });

//                 if (result.success) {
//                     alert('Credit note deleted successfully!');
//                     fetchCreditNotes();
//                 } else {
//                     alert('Error: ' + result.message);
//                 }
//             } catch (error) {
//                 console.error('Error deleting credit note:', error);
//                 alert('Error deleting credit note');
//             }
//         }
//     };

//     const handleSync = async (id) => {
//         try {
//             const result = await safeFetch(`${API_BASE_URL}/credit-notes/${id}/sync`, {
//                 method: 'POST',
//                 headers: getAuthHeaders()
//             });

//             if (result.success) {
//                 alert('Credit note synced to Zoho Books successfully!');
//                 fetchCreditNotes();
//             } else {
//                 alert('Sync error: ' + result.message);
//             }
//         } catch (error) {
//             console.error('Error syncing credit note:', error);
//             alert('Error syncing credit note');
//         }
//     };

//     const resetForm = () => {
//         console.log('Resetting form');
//         setFormData({
//             customer_name: '',
//             customer_zoho_id: '', // Changed field name
//             invoice_number: '',
//             invoice_date: '',
//             balance: '',
//             credit_note_amount: '',
//             currency_id: '3000000000083',
//             vat_treatment: '',
//             credit_note_number: '',
//             gst_treatment: 'business_gst',
//             tax_treatment: 'vat_registered',
//             gst_no: '',
//             source_of_supply: 'TN',
//             destination_of_supply: 'TN',
//             place_of_supply: 'DU',
//             pricebook_id: '',
//             reference_number: '',
//             is_update_customer: false,
//             exchange_rate: 1,
//             is_inclusive_tax: false,
//             location_id: '',
//             line_items: [{
//                 item_id: '',
//                 name: '',
//                 description: '',
//                 quantity: 1,
//                 unit: 'Nos',
//                 rate: 0,
//                 tax_id: '',
//                 hsn_or_sac: ''
//             }],
//             notes: '',
//             custom_fields: [],
//             company_id: currentOrganization?.organization_id || '',
//             autoSync: false
//         });
//         setCustomerSuggestions([]);
//         setShowCustomerSuggestions(false);
//     };

//     const addLineItem = () => {
//         setFormData(prev => ({
//             ...prev,
//             line_items: [...prev.line_items, {
//                 item_id: '',
//                 name: '',
//                 description: '',
//                 quantity: 1,
//                 unit: 'Nos',
//                 rate: 0,
//                 tax_id: '',
//                 hsn_or_sac: ''
//             }]
//         }));
//     };

//     const removeLineItem = (index) => {
//         if (formData.line_items.length > 1) {
//             setFormData(prev => ({
//                 ...prev,
//                 line_items: prev.line_items.filter((_, i) => i !== index)
//             }));
//         }
//     };

//     const updateLineItem = (index, field, value) => {
//         setFormData(prev => ({
//             ...prev,
//             line_items: prev.line_items.map((item, i) =>
//                 i === index ? { ...item, [field]: value } : item
//             )
//         }));
//     };

//     const getSyncStatusBadge = (status) => {
//         const badges = {
//             'pending': 'bg-yellow-100 text-yellow-800',
//             'synced': 'bg-green-100 text-green-800',
//             'error': 'bg-red-100 text-red-800'
//         };
//         return badges[status] || 'bg-gray-100 text-gray-800';
//     };

//     const filteredCreditNotes = creditNotes.filter(credit => {
//         const matchesSearch = credit.customer_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//             credit.invoice_number.toLowerCase().includes(searchTerm.toLowerCase());

//         if (filter === 'all') return matchesSearch;
//         return matchesSearch && credit.sync_status === filter;
//     });

//     if (!currentOrganization.organization_id) {
//         return (
//             <div className="max-w-7xl mx-auto p-6">
//                 <div className="bg-red-50 border border-red-200 rounded-lg p-6">
//                     <div className="flex items-center gap-3">
//                         <div className="text-red-600">⚠️</div>
//                         <div>
//                             <h3 className="text-red-800 font-semibold">Organization Not Found</h3>
//                             <p className="text-red-700 mt-1">
//                                 Unable to load the current organization. Please ensure you're logged in to Zoho Books
//                                 and have selected an organization.
//                             </p>
//                             <button
//                                 onClick={fetchCurrentOrganization}
//                                 className="mt-3 bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition-colors"
//                             >
//                                 Retry
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         );
//     }

//     return (
//         <div className="max-w-7xl mx-auto p-6">
//             <div className="flex justify-between items-center mb-6">
//                 <div>
//                     <h1 className="text-3xl font-bold text-gray-900">Credit Note Management</h1>
//                     <p className="text-gray-600 mt-1">
//                         Organization: <span className="font-medium text-blue-600">{currentOrganization.name}</span>
//                         {" "}({currentOrganization.organization_id})
//                     </p>
//                 </div>
//                 <button
//                     onClick={() => {
//                         resetForm();
//                         setShowForm(true);
//                     }}
//                     className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg flex items-center gap-2 transition-colors"
//                 >
//                     <Plus size={20} />
//                     Add Credit Note
//                 </button>
//             </div>

//             {/* Search and Filter */}
//             <div className="mb-6 flex gap-4">
//                 <div className="flex-1 relative">
//                     <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
//                     <input
//                         type="text"
//                         placeholder="Search by customer name or invoice number..."
//                         value={searchTerm}
//                         onChange={(e) => setSearchTerm(e.target.value)}
//                         className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                     />
//                 </div>
//                 <div className="flex items-center gap-2">
//                     <Filter size={20} className="text-gray-400" />
//                     <select
//                         value={filter}
//                         onChange={(e) => setFilter(e.target.value)}
//                         className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                     >
//                         <option value="all">All Status</option>
//                         <option value="pending">Pending</option>
//                         <option value="synced">Synced</option>
//                         <option value="error">Error</option>
//                     </select>
//                 </div>
//             </div>

//             {/* Credit Notes Table */}
//             <div className="bg-white rounded-lg shadow-md overflow-hidden">
//                 <div className="overflow-x-auto">
//                     <table className="w-full">
//                         <thead className="bg-gray-50">
//                             <tr>
//                                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Customer</th>
//                                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Invoice Number</th>
//                                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>
//                                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Amount</th>
//                                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
//                                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
//                             </tr>
//                         </thead>
//                         <tbody className="bg-white divide-y divide-gray-200">
//                             {isLoading ? (
//                                 <tr>
//                                     <td colSpan="6" className="px-6 py-4 text-center text-gray-500">Loading...</td>
//                                 </tr>
//                             ) : filteredCreditNotes.length === 0 ? (
//                                 <tr>
//                                     <td colSpan="6" className="px-6 py-4 text-center text-gray-500">No credit notes found</td>
//                                 </tr>
//                             ) : (
//                                 filteredCreditNotes.map((credit) => (
//                                     <tr key={credit.id} className="hover:bg-gray-50">
//                                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{credit.customer_name}</td>
//                                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{credit.invoice_number}</td>
//                                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
//                                             {credit.invoice_date ? new Date(credit.invoice_date).toLocaleDateString() : '-'}
//                                         </td>
//                                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
//                                             ₹ {parseFloat(credit.credit_note_amount || 0).toFixed(2)}
//                                         </td>
//                                         <td className="px-6 py-4 whitespace-nowrap">
//                                             <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getSyncStatusBadge(credit.sync_status)}`}>
//                                                 {credit.sync_status}
//                                             </span>
//                                         </td>
//                                         <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
//                                             <div className="flex gap-2">
//                                                 <button
//                                                     onClick={() => handleEdit(credit)}
//                                                     disabled={credit.sync_status === 'synced'}
//                                                     className={`${credit.sync_status === 'synced'
//                                                         ? 'text-gray-400 cursor-not-allowed'
//                                                         : 'text-blue-600 hover:text-blue-900'}`}
//                                                     title={credit.sync_status === 'synced' ? "Cannot edit synced credit note" : "Edit"}
//                                                 >
//                                                     <Edit2 size={16} />
//                                                 </button>
//                                                 <button
//                                                     onClick={() => handleSync(credit.id)}
//                                                     disabled={credit.sync_status === 'synced'}
//                                                     className={`${credit.sync_status === 'synced'
//                                                         ? 'text-gray-400 cursor-not-allowed'
//                                                         : 'text-green-600 hover:text-green-900'}`}
//                                                     title={credit.sync_status === 'synced' ? "Already synced to Zoho Books" : "Sync to Zoho"}
//                                                 >
//                                                     <RefreshCcw size={16} />
//                                                 </button>
//                                                 {/* Remove delete button for synced credit notes or disable it */}
//                                                 {/* {credit.sync_status !== 'synced' && (
//                                                     <button
//                                                         onClick={() => handleDelete(credit.id)}
//                                                         className="text-red-600 hover:text-red-900"
//                                                         title="Delete"
//                                                     >
//                                                         <Trash2 size={16} />
//                                                     </button>
//                                                 )} */}
//                                             </div>
//                                         </td>
//                                     </tr>
//                                 ))
//                             )}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>

//             {/* Pagination */}
//             <div className="mt-6 flex justify-between items-center">
//                 <div className="text-sm text-gray-700">
//                     Showing {(pagination.page - 1) * pagination.limit + 1} to{' '}
//                     {Math.min(pagination.page * pagination.limit, pagination.total)} of {pagination.total} results
//                 </div>
//                 <div className="flex gap-2">
//                     <button
//                         onClick={() => setPagination(prev => ({ ...prev, page: prev.page - 1 }))}
//                         disabled={pagination.page === 1}
//                         className="px-3 py-1 border border-gray-300 rounded disabled:opacity-50 disabled:cursor-not-allowed"
//                     >
//                         Previous
//                     </button>
//                     <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded">
//                         {pagination.page} / {pagination.totalPages}
//                     </span>
//                     <button
//                         onClick={() => setPagination(prev => ({ ...prev, page: prev.page + 1 }))}
//                         disabled={pagination.page === pagination.totalPages}
//                         className="px-3 py-1 border border-gray-300 rounded disabled:opacity-50 disabled:cursor-not-allowed"
//                     >
//                         Next
//                     </button>
//                 </div>
//             </div>

//             {/* Form Modal */}
//             {showForm && (
//                 <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
//                     <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto">
//                         <div className="sticky top-0 bg-white border-b px-6 py-4 flex justify-between items-center">
//                             <div>
//                                 <h2 className="text-xl font-semibold">
//                                     {editingCredit ? 'Edit Credit Note' : 'Add New Credit Note'}
//                                 </h2>
//                                 {/* NEW: Add synced status warning */}
//                                 {editingCredit?.sync_status === 'synced' && (
//                                     <div className="mt-2 flex items-center gap-2 px-3 py-2 bg-green-50 border border-green-200 rounded-lg">
//                                         <RefreshCcw className="w-4 h-4 text-green-600" />
//                                         <span className="text-sm text-green-800 font-medium">
//                                             This credit note has been synced to Zoho Books and cannot be edited
//                                         </span>
//                                     </div>
//                                 )}
//                             </div>
//                             <button
//                                 onClick={() => {
//                                     setShowForm(false);
//                                     setEditingCredit(null);
//                                     resetForm();
//                                 }}
//                                 className="text-gray-400 hover:text-gray-600"
//                             >
//                                 <X size={24} />
//                             </button>
//                         </div>

//                         <form onSubmit={handleSubmit} className="p-6 space-y-6">
//                             {/* Basic Information */}
//                             <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                                 <div className="relative">
//                                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                                         Customer Name * (Search in Zoho Books)
//                                     </label>
//                                     <input
//                                         type="text"
//                                         required
//                                         value={formData.customer_name}
//                                         onChange={(e) => handleCustomerNameChange(e.target.value)}
//                                         onBlur={handleCustomerNameBlur}
//                                         className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                                         placeholder="Start typing customer name (searches Zoho Books)..."
//                                     />
//                                     {/* Customer Suggestions Dropdown */}
//                                     {showCustomerSuggestions && customerSuggestions.length > 0 && (
//                                         <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-48 overflow-y-auto">
//                                             {customerSuggestions.map((customer) => (
//                                                 <div
//                                                     key={customer.customer_zoho_id} // Changed key
//                                                     className="px-3 py-2 hover:bg-gray-100 cursor-pointer text-sm border-b border-gray-100 last:border-b-0"
//                                                     onMouseDown={() => handleCustomerSelect(customer)}
//                                                 >
//                                                     <div className="font-medium text-gray-900">{customer.customer_name}</div>
//                                                     <div className="text-gray-500 text-xs">
//                                                         ID: {customer.customer_zoho_id} {/* Updated display */}
//                                                         {customer.gst_no && (
//                                                             <span className="ml-2">• GST: {customer.gst_no}</span>
//                                                         )}
//                                                     </div>
//                                                     {customer.gst_treatment && (
//                                                         <div className="text-gray-400 text-xs">
//                                                             Treatment: {customer.gst_treatment}
//                                                         </div>
//                                                     )}
//                                                 </div>
//                                             ))}
//                                         </div>
//                                     )}
//                                 </div>

//                                 <div>
//                                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                                         Customer Zoho ID * (From Zoho Books) {/* Updated label */}
//                                     </label>
//                                     <input
//                                         type="text"
//                                         required
//                                         value={formData.customer_zoho_id} // Changed field name
//                                         readOnly
//                                         className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 text-gray-600"
//                                         placeholder="Will be auto-filled from Zoho Books"
//                                         title={`Current Customer Zoho ID: ${formData.customer_zoho_id || 'Not set'}`} // Updated title
//                                     />
//                                     {formData.customer_zoho_id && ( // Changed field name
//                                         <div className="text-xs text-gray-500 mt-1">
//                                             ✓ Zoho Customer ID: {formData.customer_zoho_id} {/* Updated display */}
//                                         </div>
//                                     )}
//                                 </div>

//                                 <div>
//                                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                                         Invoice Number * (Search in Zoho Books)
//                                     </label>
//                                     <input
//                                         type="text"
//                                         required
//                                         value={formData.invoice_number}
//                                         onChange={(e) => handleInvoiceNumberChange(e.target.value)}
//                                         onBlur={handleInvoiceNumberBlur}
//                                         className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                                         placeholder="Enter invoice number (searches Zoho Books)..."
//                                     />
//                                 </div>

//                                 <div>
//                                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                                         Invoice Date * (From Zoho Books)
//                                     </label>
//                                     <input
//                                         type="date"
//                                         required
//                                         value={formData.invoice_date}
//                                         onChange={(e) => setFormData({ ...formData, invoice_date: e.target.value })}
//                                         className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                                     />
//                                 </div>

//                                 <div>
//                                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                                         Credit Amount * (From Zoho line items)
//                                     </label>
//                                     <input
//                                         type="number"
//                                         step="0.01"
//                                         required
//                                         value={formData.credit_note_amount}
//                                         onChange={(e) => setFormData({ ...formData, credit_note_amount: e.target.value })}
//                                         className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                                     />
//                                 </div>

//                                 <div>
//                                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                                         Balance
//                                     </label>
//                                     <input
//                                         type="number"
//                                         step="0.01"
//                                         value={formData.balance}
//                                         onChange={(e) => setFormData({ ...formData, balance: e.target.value })}
//                                         className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                                     />
//                                 </div>

//                                 <div>
//                                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                                         Credit Note Number
//                                     </label>
//                                     <input
//                                         type="text"
//                                         value={formData.credit_note_number}
//                                         onChange={(e) => setFormData({ ...formData, credit_note_number: e.target.value })}
//                                         className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                                     />
//                                 </div>

//                                 <div>
//                                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                                         Reference Number
//                                     </label>
//                                     <input
//                                         type="text"
//                                         value={formData.reference_number}
//                                         onChange={(e) => setFormData({ ...formData, reference_number: e.target.value })}
//                                         className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                                     />
//                                 </div>
//                             </div>

//                             {/* Tax Information */}
//                             <div className="border-t pt-6">
//                                 <h3 className="text-lg font-medium text-gray-900 mb-4">Tax Information (From Zoho Books Customer)</h3>
//                                 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
//                                     <div>
//                                         <label className="block text-sm font-medium text-gray-700 mb-1">
//                                             GST Treatment (From Zoho)
//                                         </label>
//                                         <select
//                                             value={formData.gst_treatment}
//                                             onChange={(e) => setFormData({ ...formData, gst_treatment: e.target.value })}
//                                             className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-gray-50"
//                                         >
//                                             <option value="business_gst">Business GST</option>
//                                             <option value="consumer">Consumer</option>
//                                             <option value="overseas">Overseas</option>
//                                         </select>
//                                     </div>

//                                     <div>
//                                         <label className="block text-sm font-medium text-gray-700 mb-1">
//                                             Tax Treatment (From Zoho)
//                                         </label>
//                                         <select
//                                             value={formData.tax_treatment}
//                                             onChange={(e) => setFormData({ ...formData, tax_treatment: e.target.value })}
//                                             className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-gray-50"
//                                         >
//                                             <option value="vat_registered">VAT Registered</option>
//                                             <option value="vat_not_registered">VAT Not Registered</option>
//                                             <option value="overseas">Overseas</option>
//                                         </select>
//                                     </div>

//                                     <div>
//                                         <label className="block text-sm font-medium text-gray-700 mb-1">
//                                             GST Number (From Zoho)
//                                         </label>
//                                         <input
//                                             type="text"
//                                             value={formData.gst_no}
//                                             readOnly
//                                             className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 text-gray-600"
//                                             placeholder="Will be auto-filled from Zoho customer data"
//                                         />
//                                     </div>

//                                     <div>
//                                         <label className="block text-sm font-medium text-gray-700 mb-1">
//                                             Source of Supply (From Zoho)
//                                         </label>
//                                         <input
//                                             type="text"
//                                             value={formData.source_of_supply}
//                                             readOnly
//                                             className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 text-gray-600"
//                                             placeholder="Will be auto-filled from Zoho customer data"
//                                         />
//                                     </div>

//                                     <div>
//                                         <label className="block text-sm font-medium text-gray-700 mb-1">
//                                             Destination of Supply (From Zoho)
//                                         </label>
//                                         <input
//                                             type="text"
//                                             value={formData.destination_of_supply}
//                                             readOnly
//                                             className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 text-gray-600"
//                                             placeholder="Will be auto-filled from Zoho customer data"
//                                         />
//                                     </div>

//                                     <div>
//                                         <label className="block text-sm font-medium text-gray-700 mb-1">
//                                             Place of Supply (From Zoho)
//                                         </label>
//                                         <input
//                                             type="text"
//                                             value={formData.place_of_supply}
//                                             readOnly
//                                             className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 text-gray-600"
//                                             placeholder="Will be auto-filled from Zoho customer data"
//                                         />
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Line Items */}
//                             <div className="border-t pt-6">
//                                 <div className="flex justify-between items-center mb-4">
//                                     <h3 className="text-lg font-medium text-gray-900">Line Items (From Zoho Books Invoice)</h3>
//                                     <button
//                                         type="button"
//                                         onClick={addLineItem}
//                                         className="bg-green-600 hover:bg-green-700 text-white px-3 py-1 rounded text-sm flex items-center gap-1"
//                                     >
//                                         <Plus size={16} />
//                                         Add Item
//                                     </button>
//                                 </div>

//                                 <div className="space-y-4">
//                                     {formData.line_items.map((item, index) => (
//                                         <div key={index} className="border border-gray-200 rounded-lg p-4">
//                                             <div className="flex justify-between items-center mb-3">
//                                                 <h4 className="font-medium text-gray-900">Item {index + 1}</h4>
//                                                 {formData.line_items.length > 1 && (
//                                                     <button
//                                                         type="button"
//                                                         onClick={() => removeLineItem(index)}
//                                                         className="text-red-600 hover:text-red-800"
//                                                     >
//                                                         <X size={16} />
//                                                     </button>
//                                                 )}
//                                             </div>

//                                             <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
//                                                 <div>
//                                                     <label className="block text-xs font-medium text-gray-700 mb-1">
//                                                         Item Name *
//                                                     </label>
//                                                     <input
//                                                         type="text"
//                                                         required
//                                                         value={item.name}
//                                                         onChange={(e) => updateLineItem(index, 'name', e.target.value)}
//                                                         className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent"
//                                                     />
//                                                 </div>

//                                                 <div>
//                                                     <label className="block text-xs font-medium text-gray-700 mb-1">
//                                                         Description
//                                                     </label>
//                                                     <input
//                                                         type="text"
//                                                         value={item.description}
//                                                         onChange={(e) => updateLineItem(index, 'description', e.target.value)}
//                                                         className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent"
//                                                     />
//                                                 </div>

//                                                 <div>
//                                                     <label className="block text-xs font-medium text-gray-700 mb-1">
//                                                         HSN/SAC
//                                                     </label>
//                                                     <input
//                                                         type="text"
//                                                         value={item.hsn_or_sac}
//                                                         onChange={(e) => updateLineItem(index, 'hsn_or_sac', e.target.value)}
//                                                         className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent"
//                                                     />
//                                                 </div>

//                                                 <div>
//                                                     <label className="block text-xs font-medium text-gray-700 mb-1">
//                                                         Quantity * (Editable)
//                                                     </label>
//                                                     <input
//                                                         type="number"
//                                                         required
//                                                         min="0"
//                                                         step="0.01"
//                                                         value={item.quantity}
//                                                         onChange={(e) => updateLineItem(index, 'quantity', parseFloat(e.target.value) || 0)}
//                                                         className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent"
//                                                     />
//                                                 </div>

//                                                 <div>
//                                                     <label className="block text-xs font-medium text-gray-700 mb-1">
//                                                         Unit
//                                                     </label>
//                                                     <input
//                                                         type="text"
//                                                         value={item.unit}
//                                                         onChange={(e) => updateLineItem(index, 'unit', e.target.value)}
//                                                         className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent"
//                                                     />
//                                                 </div>

//                                                 <div>
//                                                     <label className="block text-xs font-medium text-gray-700 mb-1">
//                                                         Rate * (Editable)
//                                                     </label>
//                                                     <input
//                                                         type="number"
//                                                         required
//                                                         min="0"
//                                                         step="0.01"
//                                                         value={item.rate}
//                                                         onChange={(e) => updateLineItem(index, 'rate', parseFloat(e.target.value) || 0)}
//                                                         className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent"
//                                                     />
//                                                 </div>

//                                                 <div className="md:col-span-2 lg:col-span-1">
//                                                     <label className="block text-xs font-medium text-gray-700 mb-1">
//                                                         Total: ₹ {(item.quantity * item.rate).toFixed(2)}
//                                                     </label>
//                                                     <div className="h-8 bg-gray-50 rounded flex items-center px-2 text-sm text-gray-600">
//                                                         Calculated automatically
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     ))}
//                                 </div>
//                             </div>

//                             {/* Additional Information */}
//                             <div className="border-t pt-6">
//                                 <h3 className="text-lg font-medium text-gray-900 mb-4">Additional Information</h3>
//                                 <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                                     <div>
//                                         <label className="block text-sm font-medium text-gray-700 mb-1">
//                                             Currency ID
//                                         </label>
//                                         <input
//                                             type="text"
//                                             value={formData.currency_id}
//                                             onChange={(e) => setFormData({ ...formData, currency_id: e.target.value })}
//                                             className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                                         />
//                                     </div>

//                                     <div>
//                                         <label className="block text-sm font-medium text-gray-700 mb-1">
//                                             Exchange Rate
//                                         </label>
//                                         <input
//                                             type="number"
//                                             step="0.0001"
//                                             value={formData.exchange_rate}
//                                             onChange={(e) => setFormData({ ...formData, exchange_rate: parseFloat(e.target.value) || 1 })}
//                                             className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                                         />
//                                     </div>

//                                     <div>
//                                         <label className="block text-sm font-medium text-gray-700 mb-1">
//                                             Location ID
//                                         </label>
//                                         <input
//                                             type="text"
//                                             value={formData.location_id}
//                                             onChange={(e) => setFormData({ ...formData, location_id: e.target.value })}
//                                             className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                                         />
//                                     </div>

//                                     <div className="flex items-center space-x-6">
//                                         <label className="flex items-center">
//                                             <input
//                                                 type="checkbox"
//                                                 checked={formData.is_inclusive_tax}
//                                                 onChange={(e) => setFormData({ ...formData, is_inclusive_tax: e.target.checked })}
//                                                 className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
//                                             />
//                                             <span className="ml-2 text-sm text-gray-700">Inclusive Tax</span>
//                                         </label>

//                                         <label className="flex items-center">
//                                             <input
//                                                 type="checkbox"
//                                                 checked={formData.autoSync}
//                                                 onChange={(e) => setFormData({ ...formData, autoSync: e.target.checked })}
//                                                 className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
//                                             />
//                                             <span className="ml-2 text-sm text-gray-700">Auto Sync to Zoho</span>
//                                         </label>
//                                     </div>
//                                 </div>

//                                 <div className="mt-4">
//                                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                                         Notes
//                                     </label>
//                                     <textarea
//                                         rows={3}
//                                         value={formData.notes}
//                                         onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
//                                         className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                                         placeholder="Additional notes about this credit note..."
//                                     />
//                                 </div>
//                             </div>

//                             {/* Form Actions */}
//                             <div className="border-t pt-6 flex justify-end gap-3">
//                                 <button
//                                     type="button"
//                                     onClick={() => {
//                                         setShowForm(false);
//                                         setEditingCredit(null);
//                                         resetForm();
//                                     }}
//                                     className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
//                                 >
//                                     Cancel
//                                 </button>
//                                 <button
//                                     type="submit"
//                                     disabled={isLoading}
//                                     className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg flex items-center gap-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
//                                 >
//                                     <Save size={16} />
//                                     {isLoading ? 'Saving...' : editingCredit ? 'Update Credit Note' : 'Create Credit Note'}
//                                 </button>
//                             </div>
//                         </form>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default CreditNoteManagement;





import { useState, useEffect, useCallback } from 'react';
import { Plus, Edit2, Trash2, RefreshCcw, Save, X, Search, Filter, CheckCircle, XCircle, Clock, AlertTriangle } from 'lucide-react';

const CreditNoteManagement = () => {
    const [creditNotes, setCreditNotes] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [editingCredit, setEditingCredit] = useState(null);
    const [customerSuggestions, setCustomerSuggestions] = useState([]);
    const [showCustomerSuggestions, setShowCustomerSuggestions] = useState(false);
    const [pagination, setPagination] = useState({
        page: 1,
        limit: 10,
        total: 0,
        totalPages: 0
    });
    const [searchTerm, setSearchTerm] = useState('');
    const [filter, setFilter] = useState('all');

    const [formData, setFormData] = useState({
        customer_name: '',
        customer_zoho_id: '',
        invoice_number: '',
        invoice_date: '',
        balance: '',
        credit_note_amount: '',
        currency_id: '3000000000083',
        vat_treatment: '',
        credit_note_number: '',
        gst_treatment: 'business_gst',
        tax_treatment: 'vat_registered',
        gst_no: '',
        source_of_supply: 'TN',
        destination_of_supply: 'TN',
        place_of_supply: 'DU',
        pricebook_id: '',
        reference_number: '',
        is_update_customer: false,
        exchange_rate: 1,
        is_inclusive_tax: false,
        location_id: '',
        line_items: [{
            item_id: '',
            name: '',
            description: '',
            quantity: 1,
            unit: 'Nos',
            rate: 0,
            tax_id: '',
            hsn_or_sac: ''
        }],
        notes: '',
        custom_fields: [],
        company_id: '',
        autoSync: false
    });

    // Organization state
    const [currentOrganization, setCurrentOrganization] = useState({
        organization_id: '',
        name: ''
    });

    const API_BASE_URL = 'https://api.zapbooksai.subraps.com/api';

    // Get authentication headers
    const getAuthHeaders = () => {
        const token = localStorage.getItem('authToken') || sessionStorage.getItem('authToken');
        return {
            'Content-Type': 'application/json',
            ...(token && { 'Authorization': `Bearer ${token}` })
        };
    };

    // Check if credit note can be edited based on approval status
    const canEdit = useCallback((creditNote) => {
        const status = creditNote.approver_status || creditNote.approvalInfo?.status;
        console.log('Edit check for credit note', creditNote.id, 'status:', status);
        // Only allow editing if explicitly approved or no status (auto-approved)
        return status === 'approved' || !status;
    }, []);

    // Check if credit note can be synced based on approval status
    const canSync = useCallback((creditNote) => {
        const status = creditNote.approver_status || creditNote.approvalInfo?.status;
        console.log('Sync check for credit note', creditNote.id, 'status:', status);
        // Only allow syncing if explicitly approved or no status (auto-approved)
        return status === 'approved' || !status;
    }, []);

    // Get approval status display component
    const getApprovalStatusDisplay = useCallback((creditNote) => {
        const status = creditNote.approver_status || creditNote.approvalInfo?.status;
        console.log('Status display for credit note', creditNote.id, '- Database status:', creditNote.approver_status, '- User type:', creditNote.user_type, '- Final status:', status);

        if (status === 'approved') {
            return (
                <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                    <CheckCircle className="w-3 h-3 mr-1" />
                    Approved
                    {creditNote.approved_by && <span className="ml-1">by {creditNote.approved_by}</span>}
                </span>
            );
        }

        if (status === 'rejected') {
            return (
                <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800">
                    <XCircle className="w-3 h-3 mr-1" />
                    Rejected
                </span>
            );
        }

        if (status === 'pending_approval') {
            return (
                <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
                    <Clock className="w-3 h-3 mr-1" />
                    Pending Approval
                </span>
            );
        }

        // Default to auto-approved for approver users
        return (
            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                <CheckCircle className="w-3 h-3 mr-1" />
                Auto-Approved
            </span>
        );
    }, []);

    // Safe fetch with better error handling
    const safeFetch = async (url, options = {}) => {
        try {
            console.log(`Making request to: ${url}`);
            console.log(`Request options:`, options);

            const response = await fetch(url, options);

            console.log(`Response status: ${response.status} ${response.statusText}`);

            if (!response.ok) {
                const errorText = await response.text();
                console.error(`HTTP Error ${response.status}:`, errorText);
                throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            }

            const result = await response.json();
            console.log(`Response data:`, result);
            return result;
        } catch (error) {
            console.error(`Fetch error for ${url}:`, error);
            throw error;
        }
    };

    // Fetch current organization
    const fetchCurrentOrganization = async () => {
        try {
            console.log('Fetching current organization...');
            const result = await safeFetch(`${API_BASE_URL}/token/status`, {
                headers: getAuthHeaders()
            });

            if (result.success && result.data.current_organization) {
                const org = result.data.current_organization;
                console.log('Current organization fetched:', org);
                setCurrentOrganization(org);
                return org.organization_id;
            } else {
                console.error('No current organization found');
                throw new Error('No current organization found');
            }
        } catch (error) {
            console.error('Error fetching current organization:', error);
            throw error;
        }
    };

    // Initialize component
    useEffect(() => {
        const initializeComponent = async () => {
            try {
                await fetchCurrentOrganization();
            } catch (error) {
                console.error('Failed to initialize component:', error);
            }
        };

        initializeComponent();
    }, []);

    // Fetch credit notes when organization is ready
    useEffect(() => {
        if (currentOrganization?.organization_id) {
            fetchCreditNotes();
        }
    }, [pagination.page, searchTerm, filter, currentOrganization?.organization_id]);

    // Search customers directly in Zoho Books
    const fetchCustomerSuggestions = useCallback(async (searchName) => {
        if (!searchName || searchName.length < 2 || !currentOrganization?.organization_id) {
            setCustomerSuggestions([]);
            return;
        }

        try {
            console.log(`Searching for customers in Zoho with name: "${searchName}"`);

            const url = new URL(`${API_BASE_URL}/customers/search-zoho`);
            url.searchParams.set('name', searchName);
            url.searchParams.set('company_id', currentOrganization.organization_id);

            console.log(`Search URL: ${url.toString()}`);

            const result = await safeFetch(url.toString(), {
                headers: getAuthHeaders()
            });

            if (result.success && result.data) {
                setCustomerSuggestions(result.data);
                console.log('Customer suggestions set:', result.data);
            } else {
                setCustomerSuggestions([]);
                console.log('No customer suggestions found');
            }
        } catch (error) {
            console.error('Error fetching customer suggestions:', error);
            setCustomerSuggestions([]);
        }
    }, [currentOrganization?.organization_id]);

    // Get customer details directly from Zoho Books
    const fetchCustomerDetails = useCallback(async (customerZohoId) => {
        if (!customerZohoId || !currentOrganization?.organization_id) {
            console.log('No customer Zoho ID or organization ID provided');
            return;
        }

        try {
            console.log(`Fetching customer details from Zoho for ID: ${customerZohoId}`);

            const url = new URL(`${API_BASE_URL}/customers/details-zoho`);
            url.searchParams.set('customer_zoho_id', customerZohoId);
            url.searchParams.set('company_id', currentOrganization.organization_id);

            console.log(`Details URL: ${url.toString()}`);

            const result = await safeFetch(url.toString(), {
                headers: getAuthHeaders()
            });

            if (result.success && result.data) {
                const customerData = result.data;
                console.log('Customer data received from Zoho:', customerData);

                setFormData(prevFormData => {
                    const updatedFormData = {
                        ...prevFormData,
                        customer_zoho_id: customerData.customer_zoho_id || '',
                        gst_no: customerData.gst_no || '',
                        gst_treatment: customerData.gst_treatment || 'business_gst',
                        tax_treatment: customerData.tax_treatment || 'vat_registered',
                        source_of_supply: customerData.source_of_supply || 'TN',
                        destination_of_supply: customerData.destination_of_supply || 'TN',
                        place_of_supply: customerData.place_of_supply || 'DU'
                    };
                    console.log('Form data updated with Zoho customer info:', updatedFormData);
                    console.log('Customer Zoho ID set to:', updatedFormData.customer_zoho_id);
                    return updatedFormData;
                });

            } else {
                console.log('Customer not found in Zoho, resetting fields');
                setFormData(prevFormData => ({
                    ...prevFormData,
                    customer_zoho_id: '',
                    gst_no: '',
                    gst_treatment: 'business_gst',
                    tax_treatment: 'vat_registered',
                    source_of_supply: 'TN',
                    destination_of_supply: 'TN',
                    place_of_supply: 'DU'
                }));
            }
        } catch (error) {
            console.error('Error fetching customer details from Zoho:', error);
            alert(`Error fetching customer details: ${error.message}`);
        }
    }, [currentOrganization?.organization_id]);

    // Invoice line items fetching from Zoho Books
    const fetchInvoiceLineItems = useCallback(async (invoiceNumber, customerZohoId) => {
        if (!invoiceNumber || !invoiceNumber.trim() || !currentOrganization?.organization_id) {
            console.log('No invoice number or organization ID provided');
            return;
        }

        try {
            console.log(`Fetching line items from Zoho for invoice: "${invoiceNumber}", customer: "${customerZohoId}"`);
            setIsLoading(true);

            const url = new URL(`${API_BASE_URL}/invoices/line-items-zoho`);
            url.searchParams.set('invoice_number', invoiceNumber.trim());
            url.searchParams.set('company_id', currentOrganization.organization_id);

            if (customerZohoId && customerZohoId.trim()) {
                url.searchParams.set('customer_zoho_id', customerZohoId.trim());
            }

            console.log(`Line items URL: ${url.toString()}`);

            const result = await safeFetch(url.toString(), {
                headers: getAuthHeaders()
            });

            if (result.success && result.data) {
                const invoiceData = result.data;
                console.log('Invoice data received from Zoho:', invoiceData);

                setFormData(prevFormData => {
                    const updatedFormData = {
                        ...prevFormData,
                        invoice_date: invoiceData.invoice_date ? new Date(invoiceData.invoice_date).toISOString().split('T')[0] : prevFormData.invoice_date,
                        line_items: (invoiceData.line_items && invoiceData.line_items.length > 0) ? invoiceData.line_items : prevFormData.line_items,
                        credit_note_amount: invoiceData.total_amount ? invoiceData.total_amount.toString() : prevFormData.credit_note_amount,
                        place_of_supply: invoiceData.place_of_supply || prevFormData.place_of_supply
                    };
                    console.log('Form data updated with Zoho invoice info:', updatedFormData);
                    return updatedFormData;
                });

            } else {
                console.log('Invoice not found in Zoho:', result.message);
                alert('Invoice not found or no line items available');
            }
        } catch (error) {
            console.error('Error fetching invoice line items from Zoho:', error);
            alert(`Error fetching invoice details: ${error.message}`);
        } finally {
            setIsLoading(false);
        }
    }, [currentOrganization?.organization_id]);

    // Handle customer name change with debouncing
    const handleCustomerNameChange = async (value) => {
        console.log('Customer name changed to:', value);

        setFormData(prev => ({ ...prev, customer_name: value }));

        if (value && value.length >= 2) {
            await fetchCustomerSuggestions(value);
            setShowCustomerSuggestions(true);
        } else {
            setShowCustomerSuggestions(false);
            setCustomerSuggestions([]);
        }
    };

    // Handle customer selection from dropdown
    const handleCustomerSelect = async (customer) => {
        console.log('Customer selected:', customer);

        setFormData(prev => ({
            ...prev,
            customer_name: customer.customer_name,
            customer_zoho_id: customer.customer_zoho_id
        }));
        setShowCustomerSuggestions(false);
        setCustomerSuggestions([]);

        // Fetch additional customer details after selection
        await fetchCustomerDetails(customer.customer_zoho_id);
    };

    // Handle customer name blur
    const handleCustomerNameBlur = async () => {
        console.log('Customer name blur event');

        // Hide suggestions after a delay to allow for clicks
        setTimeout(() => {
            setShowCustomerSuggestions(false);
        }, 200);

        // If there's a customer name but no customer_zoho_id, try to find exact match
        if (formData.customer_name && formData.customer_name.trim() && !formData.customer_zoho_id) {
            await fetchCustomerSuggestions(formData.customer_name.trim());
        }
    };

    // Handle invoice number change
    const handleInvoiceNumberChange = (value) => {
        console.log('Invoice number changed to:', value);
        setFormData(prev => ({ ...prev, invoice_number: value }));
    };

    // Handle invoice number blur (fetch line items)
    const handleInvoiceNumberBlur = async () => {
        console.log('Invoice number blur event');

        if (formData.invoice_number && formData.invoice_number.trim() && formData.customer_zoho_id && formData.customer_zoho_id.trim()) {
            await fetchInvoiceLineItems(formData.invoice_number.trim(), formData.customer_zoho_id.trim());
        }
    };

    const fetchCreditNotes = async () => {
        if (!currentOrganization?.organization_id) {
            console.log('No organization ID available, skipping load');
            return;
        }

        setIsLoading(true);
        try {
            const url = new URL(`${API_BASE_URL}/credit-notes`);
            url.searchParams.set('page', pagination.page);
            url.searchParams.set('limit', pagination.limit);
            url.searchParams.set('company_id', currentOrganization.organization_id);

            console.log('Fetching credit notes with URL:', url.toString());

            const result = await safeFetch(url.toString(), {
                headers: getAuthHeaders()
            });

            if (result.success) {
                console.log('Credit notes received:', result.data.creditNotes);

                setCreditNotes(result.data.creditNotes);
                setPagination(prev => ({
                    ...prev,
                    total: result.data.total,
                    totalPages: result.data.totalPages
                }));
            } else {
                console.error('Failed to fetch credit notes:', result.message);
            }
        } catch (error) {
            console.error('Error fetching credit notes:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log('Submitting form with data:', formData);

        // Enhanced validation for required fields
        if (!formData.customer_name || !formData.customer_name.trim()) {
            alert('Customer name is required');
            return;
        }

        if (!formData.customer_zoho_id || !formData.customer_zoho_id.trim()) {
            alert('Customer Zoho ID is required. Please select a valid customer from the dropdown.');
            return;
        }

        if (!currentOrganization?.organization_id) {
            alert('No organization selected. Please ensure you are logged into Zoho Books.');
            return;
        }

        // Additional validation...
        if (!formData.invoice_number || !formData.invoice_number.trim()) {
            alert('Invoice number is required');
            return;
        }

        if (!formData.invoice_date) {
            alert('Invoice date is required');
            return;
        }

        if (!formData.credit_note_amount || parseFloat(formData.credit_note_amount) <= 0) {
            alert('Credit note amount must be greater than 0');
            return;
        }

        // Validate line items
        if (!formData.line_items || formData.line_items.length === 0) {
            alert('At least one line item is required');
            return;
        }

        const validLineItems = formData.line_items.filter(item =>
            item.name && item.name.trim() !== '' &&
            item.quantity > 0
        );

        if (validLineItems.length === 0) {
            alert('At least one valid line item with name and quantity > 0 is required');
            return;
        }

        setIsLoading(true);

        try {
            // Format the data for backend with current organization
            const formattedData = {
                ...formData,
                customer_zoho_id: formData.customer_zoho_id.toString().trim(),
                customer_name: formData.customer_name.trim(),
                company_id: currentOrganization.organization_id,
                invoice_date: formData.invoice_date ? new Date(formData.invoice_date).toISOString() : null,
                credit_note_amount: parseFloat(formData.credit_note_amount) || 0,
                balance: formData.balance ? parseFloat(formData.balance) : null,
                exchange_rate: parseFloat(formData.exchange_rate) || 1,
                is_update_customer: Boolean(formData.is_update_customer),
                is_inclusive_tax: Boolean(formData.is_inclusive_tax),
                autoSync: Boolean(formData.autoSync),
                line_items: validLineItems
            };

            console.log('Sending formatted data:', formattedData);
            console.log('Final customer_zoho_id being sent:', formattedData.customer_zoho_id);
            console.log('Organization ID being sent:', formattedData.company_id);

            const url = editingCredit ? `${API_BASE_URL}/credit-notes/${editingCredit.id}` : `${API_BASE_URL}/credit-notes`;
            const method = editingCredit ? 'PUT' : 'POST';

            const result = await safeFetch(url, {
                method,
                headers: getAuthHeaders(),
                body: JSON.stringify(formattedData),
            });

            if (result.success) {
                setShowForm(false);
                setEditingCredit(null);
                resetForm();
                alert(editingCredit ? 'Credit Note updated successfully!' : 'Credit Note created successfully!');
                fetchCreditNotes();
            } else {
                alert('Error: ' + result.message);
            }
        } catch (error) {
            console.error('Error saving credit note:', error);
            alert('Error saving credit note: ' + error.message);
        } finally {
            setIsLoading(false);
        }
    };

    // Handle edit with approval check
    const handleEdit = (credit) => {
        console.log('Editing credit note:', credit);

        // Check if credit note can be edited
        if (!canEdit(credit)) {
            const status = credit.approver_status || credit.approvalInfo?.status;
            let message = 'This credit note cannot be edited - ';
            if (status === 'pending_approval') {
                message += 'pending approval';
            } else if (status === 'rejected') {
                message += 'rejected';
            } else {
                message += 'not approved';
            }
            alert(message);
            return;
        }

        if (credit.zoho_credit_id) {
            alert('This credit note has already been synced to Zoho Books and cannot be edited to maintain data consistency.');
            return;
        }

        setEditingCredit(credit);

        // Convert DB date to local date string
        const dbDate = credit.invoice_date ? new Date(credit.invoice_date) : null;
        const localDate = dbDate ?
            `${dbDate.getFullYear()}-${String(dbDate.getMonth() + 1).padStart(2, '0')}-${String(dbDate.getDate()).padStart(2, '0')}` :
            '';

        // Enhanced line items parsing
        let parsedLineItems = [];
        try {
            if (credit.line_items) {
                if (typeof credit.line_items === 'string') {
                    parsedLineItems = JSON.parse(credit.line_items);
                } else if (Array.isArray(credit.line_items)) {
                    parsedLineItems = credit.line_items;
                } else if (typeof credit.line_items === 'object') {
                    parsedLineItems = [credit.line_items];
                } else {
                    parsedLineItems = [];
                }
            }
        } catch (e) {
            console.error('Error parsing line items:', e);
            parsedLineItems = [];
        }

        // Format and validate line items
        const formattedLineItems = parsedLineItems
            .filter(item => item && typeof item === 'object')
            .map(item => ({
                item_id: item.item_id || '',
                name: item.name || '',
                description: item.description || '',
                quantity: parseFloat(item.quantity) || 1,
                unit: item.unit || 'Nos',
                rate: parseFloat(item.rate) || 0,
                tax_id: item.tax_id || '',
                hsn_or_sac: item.hsn_or_sac || '',
                account_id: item.account_id || ''
            }))
            .filter(item => item.name.trim() !== '' || item.rate > 0 || item.quantity > 0);

        // If no valid line items, add a default one
        if (formattedLineItems.length === 0) {
            formattedLineItems.push({
                item_id: '',
                name: '',
                description: '',
                quantity: 1,
                unit: 'Nos',
                rate: 0,
                tax_id: '',
                hsn_or_sac: '',
                account_id: ''
            });
        }

        // Set all form data
        const editFormData = {
            customer_name: credit.customer_name || '',
            customer_zoho_id: credit.customer_zoho_id || '',
            invoice_number: credit.invoice_number || '',
            invoice_date: localDate,
            balance: credit.balance || '',
            credit_note_amount: credit.credit_note_amount || '',
            currency_id: credit.currency_id || '3000000000083',
            vat_treatment: credit.vat_treatment || '',
            credit_note_number: credit.credit_note_number || '',
            gst_treatment: credit.gst_treatment || 'business_gst',
            tax_treatment: credit.tax_treatment || 'vat_registered',
            gst_no: credit.gst_no || '',
            source_of_supply: credit.source_of_supply || 'TN',
            destination_of_supply: credit.destination_of_supply || 'TN',
            place_of_supply: credit.place_of_supply || 'DU',
            pricebook_id: credit.pricebook_id || '',
            reference_number: credit.reference_number || '',
            is_update_customer: credit.is_update_customer || false,
            exchange_rate: credit.exchange_rate || 1,
            is_inclusive_tax: credit.is_inclusive_tax || false,
            location_id: credit.location_id || '',
            line_items: formattedLineItems,
            notes: credit.notes || '',
            custom_fields: credit.custom_fields || [],
            company_id: credit.company_id || currentOrganization?.organization_id,
            autoSync: false
        };

        console.log('Setting edit form data:', editFormData);
        setFormData(editFormData);
        setShowForm(true);
    };

    const handleDelete = async (id) => {
        if (window.confirm('Are you sure you want to delete this credit note?')) {
            try {
                const result = await safeFetch(`${API_BASE_URL}/credit-notes/${id}`, {
                    method: 'DELETE',
                    headers: getAuthHeaders()
                });

                if (result.success) {
                    alert('Credit note deleted successfully!');
                    fetchCreditNotes();
                } else {
                    alert('Error: ' + result.message);
                }
            } catch (error) {
                console.error('Error deleting credit note:', error);
                alert('Error deleting credit note');
            }
        }
    };

    // Handle sync with approval check
    const handleSync = async (id) => {
        try {
            // Find the credit note to check approval status
            const creditNote = creditNotes.find(cn => cn.id === id);

            // Check if credit note can be synced
            if (!canSync(creditNote)) {
                const status = creditNote.approver_status || creditNote.approvalInfo?.status;
                let message = 'This credit note cannot be synced - ';
                if (status === 'pending_approval') {
                    message += 'pending approval';
                } else if (status === 'rejected') {
                    message += 'rejected';
                } else {
                    message += 'not approved';
                }
                alert(message);
                return;
            }

            const result = await safeFetch(`${API_BASE_URL}/credit-notes/${id}/sync`, {
                method: 'POST',
                headers: getAuthHeaders()
            });

            if (result.success) {
                alert('Credit note synced to Zoho Books successfully!');
                fetchCreditNotes();
            } else {
                alert('Sync error: ' + result.message);
            }
        } catch (error) {
            console.error('Error syncing credit note:', error);
            alert('Error syncing credit note');
        }
    };

    const resetForm = () => {
        console.log('Resetting form');
        setFormData({
            customer_name: '',
            customer_zoho_id: '',
            invoice_number: '',
            invoice_date: '',
            balance: '',
            credit_note_amount: '',
            currency_id: '3000000000083',
            vat_treatment: '',
            credit_note_number: '',
            gst_treatment: 'business_gst',
            tax_treatment: 'vat_registered',
            gst_no: '',
            source_of_supply: 'TN',
            destination_of_supply: 'TN',
            place_of_supply: 'DU',
            pricebook_id: '',
            reference_number: '',
            is_update_customer: false,
            exchange_rate: 1,
            is_inclusive_tax: false,
            location_id: '',
            line_items: [{
                item_id: '',
                name: '',
                description: '',
                quantity: 1,
                unit: 'Nos',
                rate: 0,
                tax_id: '',
                hsn_or_sac: ''
            }],
            notes: '',
            custom_fields: [],
            company_id: currentOrganization?.organization_id || '',
            autoSync: false
        });
        setCustomerSuggestions([]);
        setShowCustomerSuggestions(false);
    };

    const addLineItem = () => {
        setFormData(prev => ({
            ...prev,
            line_items: [...prev.line_items, {
                item_id: '',
                name: '',
                description: '',
                quantity: 1,
                unit: 'Nos',
                rate: 0,
                tax_id: '',
                hsn_or_sac: ''
            }]
        }));
    };

    const removeLineItem = (index) => {
        if (formData.line_items.length > 1) {
            setFormData(prev => ({
                ...prev,
                line_items: prev.line_items.filter((_, i) => i !== index)
            }));
        }
    };

    const updateLineItem = (index, field, value) => {
        setFormData(prev => ({
            ...prev,
            line_items: prev.line_items.map((item, i) =>
                i === index ? { ...item, [field]: value } : item
            )
        }));
    };

    const getSyncStatusBadge = (status) => {
        const badges = {
            'pending': 'bg-yellow-100 text-yellow-800',
            'synced': 'bg-green-100 text-green-800',
            'error': 'bg-red-100 text-red-800'
        };
        return badges[status] || 'bg-gray-100 text-gray-800';
    };

    const filteredCreditNotes = creditNotes.filter(credit => {
        const matchesSearch = credit.customer_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            credit.invoice_number.toLowerCase().includes(searchTerm.toLowerCase());

        if (filter === 'all') return matchesSearch;
        if (filter === 'approved') return matchesSearch && (credit.approver_status === 'approved' || !credit.approver_status);
        if (filter === 'pending') return matchesSearch && credit.approver_status === 'pending_approval';
        if (filter === 'rejected') return matchesSearch && credit.approver_status === 'rejected';
        return matchesSearch && credit.sync_status === filter;
    });

    if (!currentOrganization.organization_id) {
        return (
            <div className="max-w-7xl mx-auto p-6">
                <div className="bg-red-50 border border-red-200 rounded-lg p-6">
                    <div className="flex items-center gap-3">
                        <div className="text-red-600">⚠️</div>
                        <div>
                            <h3 className="text-red-800 font-semibold">Organization Not Found</h3>
                            <p className="text-red-700 mt-1">
                                Unable to load the current organization. Please ensure you're logged in to Zoho Books
                                and have selected an organization.
                            </p>
                            <button
                                onClick={fetchCurrentOrganization}
                                className="mt-3 bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition-colors"
                            >
                                Retry
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="max-w-7xl mx-auto p-6">
            <div className="flex justify-between items-center mb-6">
                <div>
                    <h1 className="text-3xl font-bold text-gray-900">Credit Note Management</h1>
                    <p className="text-gray-600 mt-1">
                        Organization: <span className="font-medium text-blue-600">{currentOrganization.name}</span>
                        {" "}({currentOrganization.organization_id})
                    </p>
                </div>
            </div>

            {/* Search and Filter */}
            <div className="mb-6 flex gap-4">
                <div className="flex-1 relative">
                    <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
                    <input
                        type="text"
                        placeholder="Search by customer name or invoice number..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    />
                </div>
                <div className="flex items-center gap-2">
                    <Filter size={20} className="text-gray-400" />
                    <select
                        value={filter}
                        onChange={(e) => setFilter(e.target.value)}
                        className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    >
                        <option value="all">All Status</option>
                        <option value="approved">Approved</option>
                        <option value="pending">Pending Approval</option>
                        <option value="rejected">Rejected</option>
                        <option value="synced">Synced</option>
                        <option value="error">Sync Error</option>
                    </select>
                </div>
            </div>

            {/* Credit Notes Table */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden">
                <div className="overflow-x-auto">
                    <table className="w-full">
                        <thead className="bg-gray-50">
                            <tr>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Customer</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Invoice Number</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Amount</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Approval Status</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Sync Status</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                            {isLoading ? (
                                <tr>
                                    <td colSpan="7" className="px-6 py-4 text-center text-gray-500">Loading...</td>
                                </tr>
                            ) : filteredCreditNotes.length === 0 ? (
                                <tr>
                                    <td colSpan="7" className="px-6 py-4 text-center text-gray-500">No credit notes found</td>
                                </tr>
                            ) : (
                                filteredCreditNotes.map((credit) => (
                                    <tr key={credit.id} className="hover:bg-gray-50">
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{credit.customer_name}</td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{credit.invoice_number}</td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                            {credit.invoice_date ? new Date(credit.invoice_date).toLocaleDateString() : '-'}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                            ₹ {parseFloat(credit.credit_note_amount || 0).toFixed(2)}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            {getApprovalStatusDisplay(credit)}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getSyncStatusBadge(credit.sync_status)}`}>
                                                {credit.sync_status}
                                            </span>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                                            <div className="flex gap-2">
                                                <button
                                                    onClick={() => handleEdit(credit)}
                                                    disabled={credit.sync_status === 'synced' || !canEdit(credit)}
                                                    className={`${(credit.sync_status === 'synced' || !canEdit(credit))
                                                        ? 'text-gray-400 cursor-not-allowed'
                                                        : 'text-blue-600 hover:text-blue-900'}`}
                                                    title={
                                                        credit.sync_status === 'synced'
                                                            ? "Cannot edit synced credit note"
                                                            : !canEdit(credit)
                                                                ? "Cannot edit - approval required"
                                                                : "Edit"
                                                    }
                                                >
                                                    <Edit2 size={16} />
                                                </button>
                                                <button
                                                    onClick={() => handleSync(credit.id)}
                                                    disabled={credit.sync_status === 'synced' || !canSync(credit)}
                                                    className={`${(credit.sync_status === 'synced' || !canSync(credit))
                                                        ? 'text-gray-400 cursor-not-allowed'
                                                        : 'text-green-600 hover:text-green-900'}`}
                                                    title={
                                                        credit.sync_status === 'synced'
                                                            ? "Already synced to Zoho Books"
                                                            : !canSync(credit)
                                                                ? "Cannot sync - approval required"
                                                                : "Sync to Zoho"
                                                    }
                                                >
                                                    <RefreshCcw size={16} />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Pagination */}
            <div className="mt-6 flex justify-between items-center">
                <div className="text-sm text-gray-700">
                    Showing {(pagination.page - 1) * pagination.limit + 1} to{' '}
                    {Math.min(pagination.page * pagination.limit, pagination.total)} of {pagination.total} results
                </div>
                <div className="flex gap-2">
                    <button
                        onClick={() => setPagination(prev => ({ ...prev, page: prev.page - 1 }))}
                        disabled={pagination.page === 1}
                        className="px-3 py-1 border border-gray-300 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        Previous
                    </button>
                    <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded">
                        {pagination.page} / {pagination.totalPages}
                    </span>
                    <button
                        onClick={() => setPagination(prev => ({ ...prev, page: prev.page + 1 }))}
                        disabled={pagination.page === pagination.totalPages}
                        className="px-3 py-1 border border-gray-300 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        Next
                    </button>
                </div>
            </div>

            {/* Form Modal */}
            {showForm && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto">
                        <div className="sticky top-0 bg-white border-b px-6 py-4 flex justify-between items-center">
                            <div>
                                <h2 className="text-xl font-semibold">
                                    {editingCredit ? 'Edit Credit Note' : 'Add New Credit Note'}
                                </h2>
                                {/* Add approval status warnings for editing */}
                                {editingCredit?.sync_status === 'synced' && (
                                    <div className="mt-2 flex items-center gap-2 px-3 py-2 bg-green-50 border border-green-200 rounded-lg">
                                        <RefreshCcw className="w-4 h-4 text-green-600" />
                                        <span className="text-sm text-green-800 font-medium">
                                            This credit note has been synced to Zoho Books and cannot be edited
                                        </span>
                                    </div>
                                )}
                                {editingCredit?.approver_status === 'pending_approval' && (
                                    <div className="mt-2 flex items-center gap-2 px-3 py-2 bg-yellow-50 border border-yellow-200 rounded-lg">
                                        <Clock className="w-4 h-4 text-yellow-600" />
                                        <span className="text-sm text-yellow-800 font-medium">
                                            This credit note is pending approval and cannot be edited
                                        </span>
                                    </div>
                                )}
                                {editingCredit?.approver_status === 'rejected' && (
                                    <div className="mt-2 flex items-center gap-2 px-3 py-2 bg-red-50 border border-red-200 rounded-lg">
                                        <XCircle className="w-4 h-4 text-red-600" />
                                        <span className="text-sm text-red-800 font-medium">
                                            This credit note has been rejected and cannot be edited
                                        </span>
                                    </div>
                                )}
                            </div>
                            <button
                                onClick={() => {
                                    setShowForm(false);
                                    setEditingCredit(null);
                                    resetForm();
                                }}
                                className="text-gray-400 hover:text-gray-600"
                            >
                                <X size={24} />
                            </button>
                        </div>

                        <form onSubmit={handleSubmit} className="p-6 space-y-6">
                            {/* Basic Information */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div className="relative">
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Customer Name * (Search in Zoho Books)
                                    </label>
                                    <input
                                        type="text"
                                        required
                                        value={formData.customer_name}
                                        onChange={(e) => handleCustomerNameChange(e.target.value)}
                                        onBlur={handleCustomerNameBlur}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                        placeholder="Start typing customer name (searches Zoho Books)..."
                                    />
                                    {/* Customer Suggestions Dropdown */}
                                    {showCustomerSuggestions && customerSuggestions.length > 0 && (
                                        <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-48 overflow-y-auto">
                                            {customerSuggestions.map((customer) => (
                                                <div
                                                    key={customer.customer_zoho_id}
                                                    className="px-3 py-2 hover:bg-gray-100 cursor-pointer text-sm border-b border-gray-100 last:border-b-0"
                                                    onMouseDown={() => handleCustomerSelect(customer)}
                                                >
                                                    <div className="font-medium text-gray-900">{customer.customer_name}</div>
                                                    <div className="text-gray-500 text-xs">
                                                        ID: {customer.customer_zoho_id}
                                                        {customer.gst_no && (
                                                            <span className="ml-2">• GST: {customer.gst_no}</span>
                                                        )}
                                                    </div>
                                                    {customer.gst_treatment && (
                                                        <div className="text-gray-400 text-xs">
                                                            Treatment: {customer.gst_treatment}
                                                        </div>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Customer Zoho ID * (From Zoho Books)
                                    </label>
                                    <input
                                        type="text"
                                        required
                                        value={formData.customer_zoho_id}
                                        readOnly
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 text-gray-600"
                                        placeholder="Will be auto-filled from Zoho Books"
                                        title={`Current Customer Zoho ID: ${formData.customer_zoho_id || 'Not set'}`}
                                    />
                                    {formData.customer_zoho_id && (
                                        <div className="text-xs text-gray-500 mt-1">
                                            ✓ Zoho Customer ID: {formData.customer_zoho_id}
                                        </div>
                                    )}
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Invoice Number * (Search in Zoho Books)
                                    </label>
                                    <input
                                        type="text"
                                        required
                                        value={formData.invoice_number}
                                        onChange={(e) => handleInvoiceNumberChange(e.target.value)}
                                        onBlur={handleInvoiceNumberBlur}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                        placeholder="Enter invoice number (searches Zoho Books)..."
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Invoice Date * (From Zoho Books)
                                    </label>
                                    <input
                                        type="date"
                                        required
                                        value={formData.invoice_date}
                                        onChange={(e) => setFormData({ ...formData, invoice_date: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Credit Amount * (From Zoho line items)
                                    </label>
                                    <input
                                        type="number"
                                        step="0.01"
                                        required
                                        value={formData.credit_note_amount}
                                        onChange={(e) => setFormData({ ...formData, credit_note_amount: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Balance
                                    </label>
                                    <input
                                        type="number"
                                        step="0.01"
                                        value={formData.balance}
                                        onChange={(e) => setFormData({ ...formData, balance: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Credit Note Number
                                    </label>
                                    <input
                                        type="text"
                                        value={formData.credit_note_number}
                                        onChange={(e) => setFormData({ ...formData, credit_note_number: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Reference Number
                                    </label>
                                    <input
                                        type="text"
                                        value={formData.reference_number}
                                        onChange={(e) => setFormData({ ...formData, reference_number: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                    />
                                </div>
                            </div>

                            {/* Tax Information */}
                            <div className="border-t pt-6">
                                <h3 className="text-lg font-medium text-gray-900 mb-4">Tax Information (From Zoho Books Customer)</h3>
                                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            GST Treatment (From Zoho)
                                        </label>
                                        <select
                                            value={formData.gst_treatment}
                                            onChange={(e) => setFormData({ ...formData, gst_treatment: e.target.value })}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-gray-50"
                                        >
                                            <option value="business_gst">Business GST</option>
                                            <option value="consumer">Consumer</option>
                                            <option value="overseas">Overseas</option>
                                        </select>
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            Tax Treatment (From Zoho)
                                        </label>
                                        <select
                                            value={formData.tax_treatment}
                                            onChange={(e) => setFormData({ ...formData, tax_treatment: e.target.value })}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-gray-50"
                                        >
                                            <option value="vat_registered">VAT Registered</option>
                                            <option value="vat_not_registered">VAT Not Registered</option>
                                            <option value="overseas">Overseas</option>
                                        </select>
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            GST Number (From Zoho)
                                        </label>
                                        <input
                                            type="text"
                                            value={formData.gst_no}
                                            readOnly
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 text-gray-600"
                                            placeholder="Will be auto-filled from Zoho customer data"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            Source of Supply (From Zoho)
                                        </label>
                                        <input
                                            type="text"
                                            value={formData.source_of_supply}
                                            readOnly
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 text-gray-600"
                                            placeholder="Will be auto-filled from Zoho customer data"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            Destination of Supply (From Zoho)
                                        </label>
                                        <input
                                            type="text"
                                            value={formData.destination_of_supply}
                                            readOnly
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 text-gray-600"
                                            placeholder="Will be auto-filled from Zoho customer data"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            Place of Supply (From Zoho)
                                        </label>
                                        <input
                                            type="text"
                                            value={formData.place_of_supply}
                                            readOnly
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 text-gray-600"
                                            placeholder="Will be auto-filled from Zoho customer data"
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Line Items */}
                            <div className="border-t pt-6">
                                <div className="flex justify-between items-center mb-4">
                                    <h3 className="text-lg font-medium text-gray-900">Line Items (From Zoho Books Invoice)</h3>
                                    <button
                                        type="button"
                                        onClick={addLineItem}
                                        className="bg-green-600 hover:bg-green-700 text-white px-3 py-1 rounded text-sm flex items-center gap-1"
                                    >
                                        <Plus size={16} />
                                        Add Item
                                    </button>
                                </div>

                                <div className="space-y-4">
                                    {formData.line_items.map((item, index) => (
                                        <div key={index} className="border border-gray-200 rounded-lg p-4">
                                            <div className="flex justify-between items-center mb-3">
                                                <h4 className="font-medium text-gray-900">Item {index + 1}</h4>
                                                {formData.line_items.length > 1 && (
                                                    <button
                                                        type="button"
                                                        onClick={() => removeLineItem(index)}
                                                        className="text-red-600 hover:text-red-800"
                                                    >
                                                        <X size={16} />
                                                    </button>
                                                )}
                                            </div>

                                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                                                <div>
                                                    <label className="block text-xs font-medium text-gray-700 mb-1">
                                                        Item Name *
                                                    </label>
                                                    <input
                                                        type="text"
                                                        required
                                                        value={item.name}
                                                        onChange={(e) => updateLineItem(index, 'name', e.target.value)}
                                                        className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                                    />
                                                </div>

                                                <div>
                                                    <label className="block text-xs font-medium text-gray-700 mb-1">
                                                        Description
                                                    </label>
                                                    <input
                                                        type="text"
                                                        value={item.description}
                                                        onChange={(e) => updateLineItem(index, 'description', e.target.value)}
                                                        className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                                    />
                                                </div>

                                                <div>
                                                    <label className="block text-xs font-medium text-gray-700 mb-1">
                                                        HSN/SAC
                                                    </label>
                                                    <input
                                                        type="text"
                                                        value={item.hsn_or_sac}
                                                        onChange={(e) => updateLineItem(index, 'hsn_or_sac', e.target.value)}
                                                        className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                                    />
                                                </div>

                                                <div>
                                                    <label className="block text-xs font-medium text-gray-700 mb-1">
                                                        Quantity * (Editable)
                                                    </label>
                                                    <input
                                                        type="number"
                                                        required
                                                        min="0"
                                                        step="0.01"
                                                        value={item.quantity}
                                                        onChange={(e) => updateLineItem(index, 'quantity', parseFloat(e.target.value) || 0)}
                                                        className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                                    />
                                                </div>

                                                <div>
                                                    <label className="block text-xs font-medium text-gray-700 mb-1">
                                                        Unit
                                                    </label>
                                                    <input
                                                        type="text"
                                                        value={item.unit}
                                                        onChange={(e) => updateLineItem(index, 'unit', e.target.value)}
                                                        className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                                    />
                                                </div>

                                                <div>
                                                    <label className="block text-xs font-medium text-gray-700 mb-1">
                                                        Rate * (Editable)
                                                    </label>
                                                    <input
                                                        type="number"
                                                        required
                                                        min="0"
                                                        step="0.01"
                                                        value={item.rate}
                                                        onChange={(e) => updateLineItem(index, 'rate', parseFloat(e.target.value) || 0)}
                                                        className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                                    />
                                                </div>

                                                <div className="md:col-span-2 lg:col-span-1">
                                                    <label className="block text-xs font-medium text-gray-700 mb-1">
                                                        Total: ₹ {(item.quantity * item.rate).toFixed(2)}
                                                    </label>
                                                    <div className="h-8 bg-gray-50 rounded flex items-center px-2 text-sm text-gray-600">
                                                        Calculated automatically
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Additional Information */}
                            <div className="border-t pt-6">
                                <h3 className="text-lg font-medium text-gray-900 mb-4">Additional Information</h3>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            Currency ID
                                        </label>
                                        <input
                                            type="text"
                                            value={formData.currency_id}
                                            onChange={(e) => setFormData({ ...formData, currency_id: e.target.value })}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            Exchange Rate
                                        </label>
                                        <input
                                            type="number"
                                            step="0.0001"
                                            value={formData.exchange_rate}
                                            onChange={(e) => setFormData({ ...formData, exchange_rate: parseFloat(e.target.value) || 1 })}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            Location ID
                                        </label>
                                        <input
                                            type="text"
                                            value={formData.location_id}
                                            onChange={(e) => setFormData({ ...formData, location_id: e.target.value })}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                        />
                                    </div>

                                    <div className="flex items-center space-x-6">
                                        <label className="flex items-center">
                                            <input
                                                type="checkbox"
                                                checked={formData.is_inclusive_tax}
                                                onChange={(e) => setFormData({ ...formData, is_inclusive_tax: e.target.checked })}
                                                className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                                            />
                                            <span className="ml-2 text-sm text-gray-700">Inclusive Tax</span>
                                        </label>

                                        <label className="flex items-center">
                                            <input
                                                type="checkbox"
                                                checked={formData.autoSync}
                                                onChange={(e) => setFormData({ ...formData, autoSync: e.target.checked })}
                                                className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                                            />
                                            <span className="ml-2 text-sm text-gray-700">Auto Sync to Zoho</span>
                                        </label>
                                    </div>
                                </div>

                                <div className="mt-4">
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Notes
                                    </label>
                                    <textarea
                                        rows={3}
                                        value={formData.notes}
                                        onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                        placeholder="Additional notes about this credit note..."
                                    />
                                </div>
                            </div>

                            {/* Form Actions */}
                            <div className="border-t pt-6 flex justify-end gap-3">
                                <button
                                    type="button"
                                    onClick={() => {
                                        setShowForm(false);
                                        setEditingCredit(null);
                                        resetForm();
                                    }}
                                    className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    disabled={isLoading}
                                    className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg flex items-center gap-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                                >
                                    <Save size={16} />
                                    {isLoading ? 'Saving...' : editingCredit ? 'Update Credit Note' : 'Create Credit Note'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CreditNoteManagement;